import React from 'react';
export function HeroImage() {
  return <section className="w-full bg-white px-6 pb-4 md:pb-6" data-id="element-98">
      <div className="max-w-4xl mx-auto flex justify-center" data-id="element-99">
        <div className="w-full md:w-3/4 lg:w-2/3 rounded-2xl overflow-hidden shadow-2xl" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/gSEdBsf2YEGqLzhMJPPRv5/53b7fbb8-3689-4cd7-821c-9bd26d3ab4b8.png" alt="Child glued to phone screen while worried parents watch from behind" className="w-full h-auto object-cover" data-id="element-101" />
        </div>
      </div>
    </section>;
}